module.exports = __webpack_public_path__ + "static/media/picto-red-slow.4ea48dd7.png";